import { Component, OnInit, Input } from '@angular/core';
import AsyncComponent from '../common/AsyncComponent';
import { StudentPinProfileModel } from './models/StudentPinProfileModel';

@Component({
  selector: 'app-student-pin-profile-widget',
  templateUrl: './student-pin-profile-widget.component.html',
  styleUrls: ['./student-pin-profile-widget.component.scss']
})
export class StudentPinProfileWidgetComponent implements OnInit, AsyncComponent {
  @Input() model: StudentPinProfileModel = null;
  // async component
  loaded: boolean;
  constructor() { }

  ngOnInit(): void {
    this.loaded = true;
  }

}
